export default function FAQSection() {
  const faqs = [
    {
      q: '香蕉漫画上的漫画可以免费阅读吗？',
      a: '是的！香蕉漫画整理推荐的漫画大部分都可以免费在线阅读，我们为您精选了各平台上的优质免费漫画资源，让您轻松畅享阅读乐趣。',
    },
    {
      q: '香蕉漫画有哪些漫画分类？',
      a: '香蕉漫画涵盖韩漫、日漫、国漫三大类别，并按风格分为恋爱、奇幻、热血、搞笑、悬疑、都市、校园、古风、冒险、科幻、治愈、惊悚等多种类型，方便您快速找到喜欢的漫画。',
    },
    {
      q: '如何找到最新最热的漫画推荐？',
      a: '您可以查看我们的"人气排行榜"板块，该榜单根据全网阅读量、收藏量和用户评分综合排序。此外也可以关注首页的"编辑精选"栏目，获取编辑团队精心挑选的高质量漫画推荐。',
    },
    {
      q: '漫画排行榜是如何计算排名的？',
      a: '我们的排行榜综合考量了漫画的阅读量、收藏数、用户评分、讨论热度等多个指标，通过科学的加权算法计算出综合排名，确保榜单的公正性和参考价值。',
    },
    {
      q: '香蕉漫画支持哪些设备阅读？',
      a: '香蕉漫画采用响应式设计，完美支持PC端、平板和手机等各类设备。无论您使用什么设备，都能获得流畅舒适的浏览和阅读体验。',
    },
    {
      q: '如何获取最新的漫画更新通知？',
      a: '您可以关注我们的社交媒体账号（微博、微信公众号），或收藏我们的网站。同时，排行榜和"编辑精选"栏目会定期更新最新的漫画推荐内容。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于香蕉漫画，您可能想了解的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h4 className="font-heading font-semibold text-foreground-900 text-sm pr-8">{faq.q}</h4>
                <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}